import styled from 'styled-components'

export const Button = styled.button`
  display: inline-block;
  color: #70b0db;
  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid #70dbd7;
  border-radius: 3px;
  display: block;
`;
